// ── 출퇴근 관리 탭 규칙 (2026-09-29 출퇴근 달력 합치기, 안 A) ──────────────────────
//   한 메뉴 "출퇴근 관리" 안에 [달력] [직원별 상세] 두 탭. 열쇠(권한 코드)는 두 개 그대로 둔다(사용자 확정).
//     달력 탭      = 출퇴근 관리 열쇠 또는 출퇴근 달력 열쇠 (지금 달력 API 가 둘 중 하나로 열어 주는 것과 같다)
//     직원별 상세 탭 = 출퇴근 관리 열쇠만 (지금 출퇴근 관리 API 가 이 열쇠만 본다)
//   열쇠가 없으면 탭도 없다(fail-closed). 첫 탭 = 달력(사용자 확정: PC·휴대폰 모두 달력 기본).

export const HUB_TITLE = '출퇴근 관리';
export const HUB_SUBTITLE = '직원 출퇴근 현황과 기록을 관리합니다.';

export const TAB_LABELS = { calendar: '달력', detail: '직원별 상세' };

function tabsFor(canCalendar, canDetail) {
  const tabs = [];
  if (canCalendar) tabs.push('calendar');
  if (canDetail) tabs.push('detail');
  return tabs;
}

/** 본사 화면 — 내 권한 코드 Set(관리자는 서버가 전부 준다). 아직 모르면(null) 탭 없음. */
export function hqAttendanceTabs(permCodes) {
  if (!permCodes || typeof permCodes.has !== 'function') return [];
  const detail = permCodes.has('ATTENDANCE_MANAGEMENT');
  const calendar = detail || permCodes.has('ATTENDANCE_CALENDAR_MANAGEMENT');
  return tabsFor(calendar, detail);
}

/**
 * 회사별 화면 — /api/my/external-companies 의 accessible_features.
 *   null = 운영자(서버가 null 로 준다) → 둘 다. 값이 없거나(undefined) 참이 아니면 닫는다.
 */
export function extAttendanceTabs(af) {
  if (af === null) return tabsFor(true, true);
  if (!af || typeof af !== 'object') return [];
  const detail = af.attendance === true;
  const calendar = detail || af.attendance_calendar === true;
  return tabsFor(calendar, detail);
}

/** 주소의 ?view= 가 열 수 있는 탭이면 그 탭, 아니면 첫 탭(달력). 열 탭이 없으면 null. */
export function pickTab(tabs, requested) {
  if (!Array.isArray(tabs) || tabs.length === 0) return null;
  return tabs.includes(requested) ? requested : tabs[0];
}
